import { Badge, IconButton, makeStyles } from "@material-ui/core";
import { useLocalStorage } from "api/useLocalStorage";
import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import React from "react";
import { isNullUndEmpty } from "utils/general";

import { RenderResourceMenuItemLink, translatedResourceName } from "./Menu";

const useStyles = makeStyles({
	customBadgeUnviewed: {
		backgroundColor: "#e74c3c",
		color: "white",
	},
	customBadgeTotal: {
		backgroundColor: "rgb(119, 136, 153, 0.8)",
		color: "white",
	},
	iconButton: {
		paddingLeft: 10,
		paddingRight: 10,
	},
});

const RenderCounterBadge = ({ viewedCount, unviewedCount }) => {
	const classes = useStyles();

	let messageCountStyle = { badge: classes.customBadgeTotal };
	let messageCount = viewedCount;
	if (unviewedCount > 0) {
		messageCountStyle = { badge: classes.customBadgeUnviewed };
		messageCount = unviewedCount;
	}

	return (
		<IconButton classes={classes.iconButton}>
			<Badge classes={messageCountStyle} badgeContent={messageCount} showZero />
		</IconButton>
	);
};

const CounterBadge = ({ dataKey }) => {
	const localStorageData = useLocalStorage();
	const { data: globalFilters = {} } = useGridUserDataGlobalFiltersContext();
	const data = localStorageData[dataKey] || {};

	// Server sends a terminal->count breakdown scoped to the user's role/company;
	// pick the count for the currently selected global terminal (or the total when none).
	if (data.hasOwnProperty("by_terminal")) {
		const terminalId = globalFilters?.terminal_id?.[0];
		const count = isNullUndEmpty(terminalId) ? data.total : data.by_terminal[terminalId] ?? 0;

		if (isNullUndEmpty(count)) {
			return null;
		}

		return <RenderCounterBadge viewedCount={0} unviewedCount={count} />;
	}

	if (data.hasOwnProperty("count")) {
		const count = data.count;

		if (isNullUndEmpty(count)) {
			return null;
		}

		return <RenderCounterBadge viewedCount={0} unviewedCount={count} />;
	}

	const { viewed_count: viewedCount = null, unviewed_count: unviewedCount = null } = data;

	if (isNullUndEmpty(viewedCount) || isNullUndEmpty(unviewedCount)) {
		return null;
	}

	return <RenderCounterBadge viewedCount={viewedCount} unviewedCount={unviewedCount} />;
};

const ResourceMenuItemWithCounter = ({ translate, resource, dataKey, ...rest }) => {
	const menuItemName = translatedResourceName(resource, translate);

	const primaryText = (
		<div>
			<span>{menuItemName}</span>
			&nbsp;
			<span>
				<CounterBadge dataKey={dataKey} />
			</span>
		</div>
	);

	return (
		<RenderResourceMenuItemLink
			{...rest}
			resource={resource}
			translate={translate}
			primaryText={primaryText}
		/>
	);
};

export const DraftOrdersMenuItem = (props) => (
	<ResourceMenuItemWithCounter {...props} dataKey="user_data_draft_orders" />
);

export const DeviationsMenuItem = (props) => (
	<ResourceMenuItemWithCounter {...props} dataKey="user_data_deviations" />
);
